/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTENT INDICATOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	contentindicator: {
		fontSize: pxToEm(14),
		fontWeight: 'bold',
		textTransform: 'capitalize',
		'&.story': {
			fontSize: pxToEm(16)
		}
	}
};